import React from 'react';
import '../../App.css';
import Hero from "../Hero";

function CurlyHair() {
    return (
        <>
          <h1> What is Curly Hair? </h1>
          <p> From Marilyn Monroe to Beyonce, ladies with curls are often envied 
              by their straight-haired counterparts. A curly coif represents freedom, 
              strength, and independence. However, curly hair can be hard to manage. 
              While you have your genes, humidity and a variety of other factors to thank 
              for whether you have curly or straight hair, scientists have discovered 
              that the shape of the follicle determines both the curvature of a strand 
              and the angle in which it grows. If the follicle is asymmetrical, the hair 
              tends to curl. Research also shows that curly hair is the result of an uneven 
              distribution of a particular type of keratin that accumulates beneath the 
              curve, on the inside edge of a curled hair.
          </p>
          </>
    );
}

export default CurlyHair;